export const authority = {
  ADMIN: { role: "ROLE_ADMIN", profile: "Amministratore", directory: "admin" },
  CONSULTANT: { role: "ROLE_CONSULTANT", profile: "Consulente", directory: "consultant" },
  COMPANY: { role: "ROLE_COMPANY", profile: "Azienda", directory: "company" },
  EMPLOYEE: { role: "ROLE_USER", profile: "Dipendente", directory: "dipendente" },
};

export const getProfile = profiles => {
  if (typeof profiles === "string") {
    profiles = [profiles];
  }
  if (profiles.includes(authority.ADMIN.role)) return authority.ADMIN;
  if (profiles.includes(authority.CONSULTANT.role)) return authority.CONSULTANT;
  if (profiles.includes(authority.COMPANY.role)) return authority.COMPANY;
  if (profiles.includes(authority.EMPLOYEE.role)) return authority.EMPLOYEE;
  return null;
};
